import * as bootstrap from "bootstrap";
import Mixitup from "mixitup";
import Swiper from 'swiper/bundle';
import AOS from "aos";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import {getElement} from "bootstrap/js/src/util";

document.addEventListener('DOMContentLoaded', function(event) {
  // Front page Main Swiper
  const mainSwiperOverlay = document.getElementsByClassName('front-page-main-swiper-overlay');
  const frontPageMainSwiper = new Swiper('#front-page-main-swiper', {
    loop: true,
    autoplay: {
      delay: 8000,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
  });

  const advantagesSwiper = new Swiper('#advantages-swiper', {
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
  });

  const urlQuery = window.location.search;
  const urlParams = new URLSearchParams(urlQuery);
  const advantagesTabControls = document.querySelectorAll('#advantages-tab-controls > button.nav-link');

  if ( advantagesTabControls ) {

    if ( urlParams.get('tab') ) {

      advantagesSwiper.slideTo((urlParams.get('tab') - 1), 600, true);

      const selectedTab = document.getElementById('advantages-section-' + urlParams.get('tab') + '-tab');

      if ( selectedTab ) {

        let tab = new bootstrap.Tab(selectedTab)

        tab.show()
      }

    }

    advantagesTabControls.forEach(function(tabControl) {

      tabControl.addEventListener('click', function() {

        advantagesSwiper.slideTo(tabControl.dataset.slideTo, 600, true);
      });
    });
  }

  const uvegezes_swiper = new Swiper('#uvegezes-swiper', {
    loop: false,
    allowTouchMove: false,
    effect: 'flip',
    flipEffect: {
      slideShadows: false,
    },
  });

  if ( urlParams.get('lang') === 'en' ) {
    var tomorRadioButton = document.getElementById('wpforms-831-field_14_1');
    var cellasRadioButton = document.getElementById('wpforms-831-field_14_2');
  } else if ( urlParams.get('lang') === 'de' ) {
    var tomorRadioButton = document.getElementById('wpforms-840-field_14_1');
    var cellasRadioButton = document.getElementById('wpforms-840-field_14_2');
  } else {
    var tomorRadioButton = document.getElementById('wpforms-454-field_14_1');
    var cellasRadioButton = document.getElementById('wpforms-454-field_14_2');
  }

  const uvegezes_swiper_controller_1 = document.getElementById("uvegezes-swiper-control-1");
  const uvegezes_swiper_controller_2 = document.getElementById("uvegezes-swiper-control-2");

  if ( uvegezes_swiper_controller_1 ) {
    uvegezes_swiper_controller_1.onclick = function() {
      uvegezes_swiper.slideTo(0, 600, true);
      if (!uvegezes_swiper_controller_1.classList.contains("active-control")) {
        uvegezes_swiper_controller_1.classList.add("active-control");
      }
      if (uvegezes_swiper_controller_2.classList.contains("active-control")) {
        uvegezes_swiper_controller_2.classList.remove("active-control");
      }
      tomorRadioButton.checked = true;
    }
  }
  if ( uvegezes_swiper_controller_2 ) {
    uvegezes_swiper_controller_2.onclick = function() {
      uvegezes_swiper.slideTo(1, 600, true);
      if (!uvegezes_swiper_controller_2.classList.contains("active-control")) {
        uvegezes_swiper_controller_2.classList.add("active-control");
      }
      if (uvegezes_swiper_controller_1.classList.contains("active-control")) {
        uvegezes_swiper_controller_1.classList.remove("active-control");
      }
      cellasRadioButton.checked = true;
    }
  }



  // Hide eu infoblokk
  var infoblokk_button = document.getElementById("eu-infoblokk-button");
  var infoblokk =  document.getElementById("eu-infoblokk-container");

  if ( infoblokk ) {
    
    infoblokk_button.onclick = function() {
      if (infoblokk_button.classList.contains("hide-infoblokk")) {
        infoblokk_button.style.transform = "rotate(180deg)";
        infoblokk_button.style.bottom = "1rem";
        infoblokk.style.transform = "translateY(" + infoblokk.offsetHeight + "px)";
        infoblokk_button.classList.remove("hide-infoblokk");
        infoblokk_button.classList.add("show-infoblokk");
      } else if (infoblokk_button.classList.contains("show-infoblokk")) {
        infoblokk_button.style.transform = "rotate(0deg)";
        infoblokk_button.style.bottom = "360px";
        infoblokk.style.transform = "translateY(0px)";
        infoblokk_button.classList.remove("show-infoblokk");
        infoblokk_button.classList.add("hide-infoblokk");
      }
    }
  }

  if ( document.getElementById("aquacrom-gallery") ) {
    var initialFilter = 'all';
    var hash = window.location.hash.replace(/^#/g, '');
    if (hash) {
        initialFilter = '.' + hash;
    }

    var aquacrom_gallery_mixer = Mixitup('#aquacrom-gallery',{
      load: {
        filter: initialFilter
      },
      selectors: {
        target: '.mixitup-row',
      },
      animation: {
        duration: 600,
        nudge: true,
        reverseOut: false,
        effects: "fade translateZ(-100px)",
        clampHeight: false,
      }
    });
  }

  const site_header = document.getElementById("site-header");
  const header_logo = document.getElementById("header-logo");
  const sticky_icons = document.getElementById("sticky-icons");

  // Sticky catalog item img
  window.onscroll = function() {
    check_scroll();
  }

  check_scroll();

  function check_scroll() {
    // var media_query = window.matchMedia("(max-width: 767.98 px)");
    if ( site_header ) {
      if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
        site_header.classList.add("sticky-header");
      } else {
        site_header.classList.remove("sticky-header");
      }
    }
    if ( sticky_icons ) {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        sticky_icons.classList.add("show-icons");
      } else {
        sticky_icons.classList.remove("show-icons");
      }
    }
  }

 const medencefedes_quote = document.getElementById("medencefedes-quote");
 const medencefedes_quote_close = document.getElementById("medencefedes-quote-close");
 const medencefedes_quote_fog = document.getElementById("medencefedes-quote-fog");
 const medencefedes_quote_button = document.getElementById("medencefedes-quote-button");

 if (medencefedes_quote_button) {
   medencefedes_quote_button.onclick = function () {
     medencefedes_quote_fog.classList.add("active");
     medencefedes_quote.classList.add("active");
   }
   medencefedes_quote_fog.onclick = function() {
     medencefedes_quote.classList.remove("active");
     medencefedes_quote_fog.classList.remove("active");
   }
   medencefedes_quote_close.onclick = function() {
     medencefedes_quote.classList.remove("active");
     medencefedes_quote_fog.classList.remove("active");
   }
 }

 const mixitup_controls = document.getElementById("mixitup-controls");
 const mixitup_controls_fog = document.getElementById("mixitup-controls-fog");
 const show_mixitup_controls_button = document.getElementById("show-mixitup-controls-button");

 if (show_mixitup_controls_button) {
   show_mixitup_controls_button.onclick = function () {
     mixitup_controls_fog.classList.add("active");
     mixitup_controls.classList.add("active");
   }
   mixitup_controls_fog.onclick = function() {
     mixitup_controls.classList.remove("active");
     mixitup_controls_fog.classList.remove("active");
   }
 }
})
